/**
 * 決定論的に使える擬似乱数。
 *
 * ping の RTT に「わずかな揺らぎ」を乗せるために使う。
 * テストではシード固定の RNG を渡すことで出力を再現できるようにする。
 */

export type Rng = () => number;

/** mulberry32。軽量で分布も十分。 */
export function createRng(seed: number): Rng {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** 既定の RNG（実行時用） */
export const defaultRng: Rng = () => Math.random();

/** 文字列から安定したシード値を作る（APIPA アドレス生成などに使う） */
export function hashString(input: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < input.length; i++) {
    h ^= input.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}
